export default __webpack_public_path__ + "static/paul-follows-27505465f1b31b052bdfe6b5f0c4cdcf.jpeg";